import { Box, Grid, Link, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import BotonComponent from './BotonNuevo';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const CardNumberComponent = ({
  color,
  textColor,
  icon,
  text,
  to,
  number,
  md = 4,
}) => {
  const history = useHistory();

  return (
    <Grid item xs={12} md={md}>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: color,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography
            variant="body"
            sx={{ fontWeight: '700', color: textColor }}
          >
            {text}
          </Typography>
          {icon}
        </Stack>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <Typography variant="h4"> {number} </Typography>
          {to && (
            <Link
              to={to}
              style={{
                color: 'black',
                textDecoration: 'none',
              }}
            >
              <BotonComponent
                click={() => {
                  history.push(to);
                }}
                blue
                text="Ver más"
              />
            </Link>
          )}
        </Box>
      </Paper>
    </Grid>
  );
};

export default CardNumberComponent;
